import React from 'react';
import styled from 'styled-components';

import { Button as ButtonAtom } from 'core/ui/atoms';

const Button = styled(ButtonAtom)`
  &:not(:disabled) {
    background: linear-gradient(
      90deg,
      ${(p) => p.theme.colors.primary},
      ${(p) => p.theme.colors.secondary}
    );
  }
  color: white;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.01em;
  min-width: 345px;
  ${(p) => p.theme.max('sm')`
    width: 100%;
    min-width: 0;
  `};
`;

export default Button;
